import { API } from "aws-amplify";

import { initData } from "utils/utilAmplify";
import { generateErrorResponse } from "utils/helpers";
import { IMatchesEnum } from "interfaces/intarfaces";

export const StudentAPI = {
  get: async (path: string = "") => {
    try {
      return await API.get("StudentHouse", path, await initData());
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  getMatches: async (path: string = "") => {
    try {
      return await API.get("StudentMatches", path, await initData());
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  post: async (path: string = "", body: IMatchesEnum) => {
    try {
      return await API.post("StudentMatches", path, {
        ...(await initData()),
        body: JSON.parse(JSON.stringify(body)),
      });
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  update: async (path: string = "", body: IMatchesEnum) => {
    try {
      return await API.post("StudentMatches", path, {
        ...(await initData()),
        body: JSON.parse(JSON.stringify(body)),
      });
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
};
